import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const WEBHOOKS_URL = getBaseUrl('/webhooks/');

export async function getWebHooks(page, size) {
    const params = new URLSearchParams({ page: page || 1 });
    if (size) params.set('size', size);
    return await appRequest.doGetRequest(`${WEBHOOKS_URL}?${params}`);
}

export async function saveWebHook(id, newWebHook) {
    if (id)
        return await appRequest.doPatchRequest(`${WEBHOOKS_URL}${id}`, newWebHook);
    else
        return await appRequest.doPostRequest(WEBHOOKS_URL, newWebHook);
}

export async function deleteWebHook(id) {
    return await appRequest.doDeleteRequest(`${WEBHOOKS_URL}${id}`);
}